import React from 'react';

import Icon from 'components/ui/Icon/Icon';

import css from './TextWithDivider.styles.scss';

export const getDateWithDateRange = (first, last, divider = '-') => {
  switch (true) {
    case Boolean(first && last):
      return `${first} ${divider} ${last}`;
    case Boolean(first):
      return first;
    case Boolean(last):
      return last;

    default:
      return '';
  }
};

export const getTextWithDivider = (first, last, divider = <Icon icon="arrows-h" size="1x" pack="fal" />) => {
  const _last = (() => {
    if (last) {
      return <span>{last}</span>;
    }

    return null;
  })();

  const _first = (() => {
    if (first) {
      return (
        <span className={css.textWithDividerFirstText}>
          {first}&nbsp;{last && divider}&nbsp;
        </span>
      );
    }

    return null;
  })();

  if (last || first) {
    return (
      <div className={css.textWithDividerContainer}>
        {_first}
        {_last}
      </div>
    );
  }

  return null;
};
